import {Component, OnDestroy, OnInit} from '@angular/core';
import {NewsService} from '../../../shared/services/news.service';
import {Observable, Subject, Subscription} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {News} from '../../../shared/interfaces/news';
import {SEOService} from '../../../shared/services/seo.service';
import {CmsService} from '../../../cms/services/cms.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss']
})
export class NewsListComponent implements OnInit, OnDestroy {

  private hasCmsEnabledSub: Subscription;
  private unsubscribe$ = new Subject;

  public legacyNews$: Observable<News[]>;

  public cmsNews: any = null;
  private allNewsSub: Subscription;
  public showCmsNews = false;

  constructor(
    private _newsService: NewsService,
    private _seoService: SEOService,
    private _cmsService: CmsService,
    private _router: Router,
    private _route: ActivatedRoute
  ) {
  }


  ngOnInit(): void {
    const contentType = this._route.snapshot.data.content;
    this._seoService.setTitle('News');

    this.legacyNews$ = this._newsService.getNews();

    this.hasCmsEnabledSub = this._cmsService.hasCmsEnabled$.subscribe(isEnabled => {
      if (isEnabled) {
        this.showCmsNews = true;
        this.allNewsSub = this._cmsService.allNews$.subscribe(news => {
          this._cmsService.siteUrl$.pipe(takeUntil(this.unsubscribe$)).subscribe(siteUrl => {
            if (news) {
              if (contentType.includes('CONAD')) {
                this.cmsNews = news.filter(x => x.attributes.some(x => x.includes('heyconad')));
              } else {
                this.cmsNews = news.filter((x) => !x.attributes.includes('heyconad') && !x.attributes.includes('heyconad_inst'));
              }
            }
          });
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.hasCmsEnabledSub.unsubscribe();
    if (this.allNewsSub) this.allNewsSub.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public goToPage(page): void {
    this._router.navigate([`${page.type.basePath}${page.path}`]);
  }

}
